// Verbose 360 tracing. Kapalı: prod konsolunda yalnızca hatalar (console.error)
// görünsün. Yerelde ayıklama yaparken true yapman yeterli — çağrılar kodda kalır.
const DEBUG_360 = false
export const log360 = (...args: any[]) => {
  if (DEBUG_360) console.log('[360]', ...args)
}


// Room number to display name mapping - API/storage still uses numbers
export const getRoomDisplayName = (roomNumber: number): string => {
  const roomMap: { [key: number]: string } = {
    1: 'Root - WW',
    2: 'Mid - WW',
    3: 'Tip - WW',
    4: 'Root - SW',
    5: 'Mid - SW',
    6: 'Tip - SW',
    7: 'Root - LW',
    8: 'Mid - LW',
    9: 'Tip - LW',
    10: 'TE',
    11: 'LE'
  }
  return roomMap[roomNumber] || `Oda ${roomNumber}`
}

// --- Blade attribution (single source of truth) --------------------------
// Both the sidebar (photo list + blade counts) and the viewer (panorama list)
// derive their photo set from these helpers, so index N in the sidebar always
// maps to index N in the viewer. When the two lists diverge, navigation looks
// like it skips photos (1,3,5,7…). Keep this the ONLY place blade logic lives.

export const extractBladeFromPath = (path?: string | null): string => {
  if (!path) return ''
  const match = path.toLowerCase().match(/blade[-_]?([abc])/i)
  return match?.[1] ? match[1].toUpperCase() : ''
}

// Blade of a photo: explicit `blade` field first, then a hint in the key/path.
// Empty string means "legacy" (no blade info anywhere).
export const getPhotoBlade = (photo: any): string => {
  const raw = photo?.blade || extractBladeFromPath(photo?.key || photo?.file_path || '')
  return raw ? String(raw).toUpperCase() : ''
}

// Legacy photos (uploaded before blade tagging) are attributed to Blade A.
export const photoMatchesBlade = (photo: any, blade: string): boolean => {
  const target = (blade || 'A').toUpperCase()
  const photoBlade = getPhotoBlade(photo)
  return photoBlade ? photoBlade === target : target === 'A'
}

// Category folders are grouping placeholders, not real room panoramas.
export const isCategoryFolderPhoto = (photo: any): boolean => {
  const key = photo?.key || ''
  return key.includes('category-') || key.includes('/category-')
}

// Same-origin image proxy URL builder. Routing panoramas through the backend
// proxy (a) sidesteps per-bucket Wasabi CORS fragility and (b) with pano=1
// resizes the equirectangular image to a power-of-two 4096x2048 so WebGL1
// (panolens/THREE r105) renders it instead of a black sphere (NPOT problem).
// Without pano/w it is a full-resolution passthrough (used when saving edits).
export const buildImageProxyUrl = (rawUrl?: string | null, opts?: { pano?: boolean }): string => {
  if (!rawUrl) return ''
  if (rawUrl.startsWith('/api/proxy-image')) return rawUrl // already proxied
  let cleanedUrl = rawUrl
  let cacheBust: string | null = null
  try {
    const parsed = new URL(rawUrl)
    // Presigned URLs already vary per request; a stray "cb" is preserved as a
    // separate param so the proxy's immutable cache can still key on it.
    cacheBust = parsed.searchParams.get('cb')
    if (cacheBust) parsed.searchParams.delete('cb')
    cleanedUrl = parsed.toString()
  } catch {
    // Non-standard URL — pass through unchanged.
  }
  const params = new URLSearchParams({ url: cleanedUrl })
  if (opts?.pano) params.set('pano', '1')
  if (cacheBust) params.set('cb', cacheBust)
  return `/api/proxy-image?${params.toString()}`
}
